import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GENETICMATERIALCROSSINGTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterialCrossingType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.GeneticMaterialCrossingType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const GENETICMATERIALCROSSINGTYPE_CONFIG = {
  entityName: 'GeneticMaterialCrossingType',
  localizationKey: 'General::Entity.GeneticMaterialCrossingType',
  fields: GENETICMATERIALCROSSINGTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterialCrossingTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
